import React, {useEffect, useState} from 'react';
import classnames from 'classnames';
import UnsupportedBrowserModal from '../UnsupportedBrowserModal';
import queryString from 'query-string';
import {NeuroMessage, useGuideConfig} from "@ignitesales/neuro-application";
import getGuideId from "../../utils/getBranchId.mjs";

const LandingPage = ({componentClass, onStartGuideClick, isLoadingNextPage}) => {
  const urlQuery = window.location.search;
  const parsed = queryString.parse(urlQuery);
  const skipLandingPage = parsed.quickStart !== undefined;
  const classes = classnames(componentClass);
  const { isBranchGuide, guideType } = useGuideConfig();
  const guideId = getGuideId({ isBranchGuide, guideType });
  const [ showBrowserModal, setShowBrowserModal ] = useState(false);
  const isIE = navigator?.userAgent?.match(/Trident/gi);
  const bannerClasses = classnames(`${componentClass}__banner`, {
    [`${componentClass}__banner--branch`]: isBranchGuide,
    [`${componentClass}__banner--online`]: !isBranchGuide,
  });
  const contentClasses = classnames(`${componentClass}__content`, {
    [`${componentClass}__content--branch`]: isBranchGuide,
    [`${componentClass}__content--online`]: !isBranchGuide,
  });

  useEffect(() => {
    if (isIE && (guideId === 170 || guideId === 173)) {
      setShowBrowserModal(true);
    }
  }, []);

  const startGuide = () => {
    onStartGuideClick('checking');
  };

  useEffect(() => {
    (skipLandingPage && !isLoadingNextPage) && onStartGuideClick()
  }, [])

  return !skipLandingPage && (
    <div className={classes}>
      {isBranchGuide && <div className={bannerClasses} />}
      <div className={contentClasses}>
        {(isBranchGuide && (
          <div>
            <h1 className="title">
              <NeuroMessage id="landing.welcome" />
            </h1>
            <NeuroMessage id="landing.message" tagName="p" className="message" />
            <button onClick={startGuide} disabled={isLoadingNextPage} className="btn btn-primary">
              <NeuroMessage id="landing.getStarted" />
            </button>
          </div>
        )) || (
          <div>
            <NeuroMessage id="landing.online.title" tagName="h1" className="title" />
            <NeuroMessage id="landing.online.message" tagName="p" className="message" />
            <NeuroMessage id="landing.online.subtitle" tagName="p" className="title" />
            <div className={`${componentClass}__step`}>
              <div className="bubble bubble--blue">1</div>
              <NeuroMessage id="landing.online.step.1" tagName="p" className="message" />
            </div>
            <div className={`${componentClass}__step`}>
              <div className="bubble bubble--blue">2</div>
              <NeuroMessage id="landing.online.step.2" tagName="p" className="message" />
            </div>
            <div className={`${componentClass}__step`}>
              <div className="bubble bubble--blue">3</div>
              <NeuroMessage id="landing.online.step.3" tagName="p" className="message" />
            </div>
            <button onClick={startGuide} disabled={isLoadingNextPage} className="btn btn-primary">
              <NeuroMessage id="landing.online.cta" />
            </button>
          </div>
        )}
      </div>
      <UnsupportedBrowserModal active={ showBrowserModal } onClose={ () => setShowBrowserModal(false) }/>
    </div>
  );
};

export default LandingPage;
